import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode';

const TotpQrCode = ({ value }) => {
  const [qrDataUrl, setQrDataUrl] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!value) return;
    let mounted = true;
    QRCode.toDataURL(value, {
      errorCorrectionLevel: 'M',
      margin: 2,
      width: 220,
      color: {
        dark: '#002E63',
        light: '#FFFFFF',
      },
    })
      .then((dataUrl) => {
        if (mounted) {
          setQrDataUrl(dataUrl);
          setError('');
        }
      })
      .catch(() => {
        if (mounted) {
          setError('No se pudo generar el QR. Usa la clave manual.');
        }
      });

    return () => {
      mounted = false;
    };
  }, [value]);

  if (error) {
    return <p className="import-empty">{error}</p>;
  }

  if (!qrDataUrl) {
    return <p className="import-empty">Generando QR...</p>;
  }

  return (
    <div className="mfa-qr">
      <img src={qrDataUrl} alt="Código QR para authenticator" />
      <span>Escanea este QR con Google Authenticator o Microsoft Authenticator.</span>
    </div>
  );
};

export default TotpQrCode;
